import React from 'react';
import IconBackground from './IconBackground';
import { ImpactUpsellIcon } from './ImpactUpsellIcon';

const TickIcon: ImpactUpsellIcon = (props) => {
  const icon = (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6166 0.17915C13.0316 0.479059 13.1244 1.05581 12.8226 1.46819L5.39385 11.619C5.23424 11.8381 4.98758 11.9737 4.71481 11.9968C4.44203 12.0198 4.17796 11.9189 3.98644 11.7286L0.27205 8.03736C-0.0906834 7.6769 -0.0906834 7.0915 0.27205 6.73103C0.634784 6.37056 1.22386 6.37056 1.5866 6.73103L4.53199 9.65803L11.3224 0.381012C11.6242 -0.0313641 12.2045 -0.123644 12.6195 0.176266L12.6166 0.17915Z"
        fill="#1F2C46"
      />
    </svg>
  );

  return props.withBackground ? (
    <IconBackground colour={props.withBackground}>{icon}</IconBackground>
  ) : (
    icon
  );
};

export default TickIcon;
